import { render, staticRenderFns } from "./DoctorCardReview.vue?vue&type=template&id=24b3c79a&scoped=true&"
import script from "./DoctorCardReview.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DoctorCardReview.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./DoctorCardReview.vue?vue&type=style&index=0&id=24b3c79a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b3c79a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24b3c79a')) {
      api.createRecord('24b3c79a', component.options)
    } else {
      api.reload('24b3c79a', component.options)
    }
    module.hot.accept("./DoctorCardReview.vue?vue&type=template&id=24b3c79a&scoped=true&", function () {
      api.rerender('24b3c79a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsList/components/DoctorCardReview.vue"
export default component.exports